export const styles = theme => ({
  boxViewFooter: {
    zIndex: 3,
    

  
    justifyContent: 'center',
    display: 'flex',
    width: '100%',
    fontFamily: theme.typography.fontKanit,
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
      right: 20,
      position: 'absolute',
      marginTop: 770,
      bottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      position: 'absolute',
      bottom: 10,
      left: 10,
    },
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
      position: 'absolute',
      bottom: 20,
    },
  },
});